import { Component } from '@angular/core';

@Component({
  selector: 'invalid-registration-link',
  templateUrl: './invalid-registration-link.component.html'
})
export class InvalidRegistrationLinkComponent {

}
